// extracted by mini-css-extract-plugin
export default {"container":"styles_container__giZZP","item":"styles_item__msUDs","label":"styles_label__9H+nU"};